module.exports = __webpack_public_path__ + "static/media/facebook_icon.6cbf15a5.svg";